export default __webpack_public_path__ + "static/AP_Icon-a84d7b4845c4692a73903cdc32803c5b.png";